import ptLang from './entries/pt_BR';
import enLang from './entries/en_US';

const AppLocale = {
  pt: ptLang,
  en: enLang,
};

export default AppLocale;
